// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"132":"545ee8e9","225":"41553fe2","947":"a071f6d6"}[chunkId] + ".chunk.js";
};